<div class=" sidebar ag-bg-black" >
  <button class="navbar-toggler d-block d-sm-block d-md-none" (click)="openMenu()" type="button"  aria-label="Toggle navigation">
    <i class="fa fa-list g-text-yellow"></i>
  </button>
    <div class="d-none d-sm-block pt-3">
      <a href="/" class="d-flex align-items-center justify-content-center mb-3 mb-md-0  text-white text-decoration-none">
        <img src="assets/images/logo-fond-noir_1@4x.png" width="60" alt="">
        <!-- <span class="fs-4">Agoodjie</span> -->
      </a>
      <hr>
      <div class="menu-content w-100">
        <ul class="" >
            @for( m of menu;  track $index; let mi = $index){
              @if(m.status && m.isTitle){
                <li  class="m-title">{{m.title}}</li>

              }

              @for( e of m.elements;  track $index; let ei = $index){

                @if(!e.isTitle && !e.hasChildren && e.status){
                  <li >
                    <a [routerLink]="e.route" routerLinkActive="mm-active" class="m-menu">
                    {{e.name}}
                    </a>
                    </li>
                }

                @else if(!e.isTitle && e.hasChildren && e.status){
                  <li  class="">
                    <a  data-bs-toggle="collapse" href="#collapse-side-{{mi}}-{{ei}}" role="button" [attr.aria-expanded]="isGroupActive(e)" [class.mm-group-active]="isGroupActive(e)" attr.aria-controls="collapse-side-{{mi}}-{{ei}}" class="m-menu">
                     {{e.name}} <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </a>
                    <ul class="collapse" [class.show]="isGroupActive(e)" id="collapse-side-{{mi}}-{{ei}}">
                      @for( sm of e.children; track $index){
                        @if(sm.status){
                          <li >
                            <a  routerLink="{{sm?.route}}" routerLinkActive="mm-active" class="m-menu">
                            {{sm?.name}}
                            </a>
                            </li>
                         }

                      }
                    </ul>
                    </li>
                }


              }

            }



        </ul>
      </div>
      <hr>
     <div class=" text-center">
      <img src="assets/images/masquotte@4x.png" width="60" alt="">
     </div>
    </div>

  </div>



  <ng-template #contentMenu let-offcanvas>

    <div class="offcanvas-header ag-bg-black">
      <h5 class="offcanvas-title  text-white" id="offcanvasNavbarLabel">Menu</h5>
      <button  id="closeMenuBtn" (click)="closeMenu()"  type="button" class="btn-close " (click)="offcanvas.dismiss('Cross click')">
        <i class="fa fa-times ag-text-red" aria-hidden="true"></i>
      </button>
    </div>
    <div class="offcanvas-body ag-bg-black">
      <ul class="" >
        @for( m of menu;  track $index; let mi = $index){
          @if(m.status && m.isTitle){
            <li  class="m-title">{{m.title}}</li>

          }

          @for( e of m.elements;  track $index; let ei = $index){

            @if(!e.isTitle && !e.hasChildren && e.status){
              <li >
                <a [routerLink]="e.route" routerLinkActive="mm-active" class="m-menu">
                {{e.name}}
                </a>
                </li>
            }

            @else if(!e.isTitle && e.hasChildren && e.status){
              <li  class="">
                <a  data-bs-toggle="collapse" href="#collapse-oc-{{mi}}-{{ei}}" role="button" [attr.aria-expanded]="isGroupActive(e)" [class.mm-group-active]="isGroupActive(e)" attr.aria-controls="collapse-oc-{{mi}}-{{ei}}" class="m-menu">
                 {{e.name}} <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
                <ul class="collapse" [class.show]="isGroupActive(e)" id="collapse-oc-{{mi}}-{{ei}}">
                  @for( sm of e.children; track $index){
                    @if(sm.status){
                      <li >
                        <a  routerLink="{{sm?.route}}" routerLinkActive="mm-active" class="m-menu">
                        {{sm?.name}}
                        </a>
                        </li>
                     }

                  }
                </ul>
                </li>
            }


          }

        }



    </ul>
    </div>
  </ng-template>
<!--
  <div class="d-block d-md-none d-flex flex-column flex-shrink-0 bg-body-tertiary" style="width: 4.5rem; height: 100vh;">
    <a href="/" class="d-block p-3 link-body-emphasis text-decoration-none" title="Icon-only" data-bs-toggle="tooltip" data-bs-placement="right">
        <img src="assets/images/logo-couleur_1@4x.png" width="30" alt="">
        <span class="visually-hidden">Icon-only</span>
    </a>
    <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
      <li class="nav-item">
        <a href="#" class="nav-link active py-3 border-bottom rounded-0" aria-current="page" title="Home" data-bs-toggle="tooltip" data-bs-placement="right">
          <svg class="bi pe-none" width="24" height="24" role="img" aria-label="Home"><use xlink:href="#home"/></svg>
        </a>
      </li>
      <li>
        <a href="#" class="nav-link py-3 border-bottom rounded-0" title="Dashboard" data-bs-toggle="tooltip" data-bs-placement="right">
          <svg class="bi pe-none" width="24" height="24" role="img" aria-label="Dashboard"><use xlink:href="#speedometer2"/></svg>
        </a>
      </li>
      <li>
        <a href="#" class="nav-link py-3 border-bottom rounded-0" title="Orders" data-bs-toggle="tooltip" data-bs-placement="right">
          <svg class="bi pe-none" width="24" height="24" role="img" aria-label="Orders"><use xlink:href="#table"/></svg>
        </a>
      </li>
      <li>
        <a href="#" class="nav-link py-3 border-bottom rounded-0" title="Products" data-bs-toggle="tooltip" data-bs-placement="right">
          <svg class="bi pe-none" width="24" height="24" role="img" aria-label="Products"><use xlink:href="#grid"/></svg>
        </a>
      </li>
      <li>
        <a href="#" class="nav-link py-3 border-bottom rounded-0" title="Customers" data-bs-toggle="tooltip" data-bs-placement="right">
          <svg class="bi pe-none" width="24" height="24" role="img" aria-label="Customers"><use xlink:href="#people-circle"/></svg>
        </a>
      </li>
    </ul>
  <div class="text-center">
    <img src="assets/images/masquotte@4x.png" width="30" alt="">

  </div>
  </div> -->
